
const SkeletonCard = ({ darkMode }) => {
  const bg = darkMode ? "bg-slate-800 border-slate-700" : "bg-white border-gray-200";
  const block1 = darkMode ? "bg-slate-700" : "bg-gray-200";
  const block2 = darkMode ? "bg-slate-600" : "bg-gray-300";

  return (
    <div className={`my-2 ${bg} rounded-lg border p-4 animate-pulse w-full`}>
      <div className="flex gap-4 w-full">
        <div className={`w-56 h-40 ${block1} rounded-lg flex-shrink-0 flex items-center justify-center`}>
          <div className="text-center">
            <div className={`w-16 h-16 ${block2} rounded-full mx-auto mb-2`} />
            <div className={`h-3 ${block2} rounded w-24 mx-auto`} />
          </div>
        </div>

        <div className="flex-1 flex flex-col justify-between">
          <div>
            <div className="flex items-center justify-between mb-3">
              <div className={`h-6 ${block1} rounded w-1/3`} />
              <div className={`w-6 h-6 ${block1} rounded`} />
            </div>
            <div className="mb-3">
              <div className="flex gap-2 mb-2">
                <div className={`h-4 ${block1} rounded w-24`} />
                <div className={`h-4 ${block1} rounded flex-1`} />
              </div>
            </div>
            <div className="flex gap-2 mb-4">
              <div className={`h-4 ${block1} rounded w-20`} />
              <div className={`h-4 ${block1} rounded w-16`} />
            </div>
          </div>
          <div className="flex gap-3 justify-end">
            <div className={`h-10 ${block1} rounded w-36`} />
            <div className={`h-10 ${block1} rounded w-36`} />
          </div>
        </div>
      </div>
    </div>
  );
};

const CardSkeleton = ({ darkMode }) => {
  return (
    <div>
      {[...Array(4)].map((_, i) => (
        <SkeletonCard key={i} darkMode={darkMode} />
      ))}
    </div>
  );
};

export default CardSkeleton;